<template>
	<div class="boardBackground" :style="nowWidth < 1081 ? 'height:auto' : ''">
		<v-layout justify-center wrap align-center>
			<!-- waitings List -->
			<v-flex xs12>
				<v-layout class="mb-2">
					<div class="board-title">
						{{ headTxt }}
					</div>
					<v-spacer></v-spacer>
					<div class="text-right">
						<v-img
							v-if="$route.params.code === 'yl3rnpvlhr'"
							src="/logo_change_board_yl3rnpvlhr.png"
							width="240"
							height="60"
							contain
						></v-img>
						<v-img v-else src="/gs-logo.png" width="60" height="60" contain></v-img>
						<!-- <v-img :src="serverUrl + logoUrl" width="83" height="60"></v-img> -->
					</div>
				</v-layout>
			</v-flex>
			<!-- 호출 번호  -->
			<v-flex lg4 xs12 class="waitListFlex" v-if="nowWidth > 1081">
				<v-layout flex-wrap>
					<v-flex xs6 class="numBar">상담석 </v-flex>
					<v-flex xs6 class="numBar">대기번호</v-flex>
				</v-layout>
				<div class="parentBox">
					<v-layout
						flex-wrap
						v-for="(waiting, i) in waitings"
						:key="i"
						align-center
						:class="i === 0 || i === waitings.length - 1 ? '' : 'waiting-border-setting'"
					>
						<v-flex xs6 :class="waitings.length < 10 ? 'waitingList1' : 'waitingList1Big'"
							>{{ waiting.seat !== 0 ? waiting.seat : '' }} {{ waiting.seat !== null ? '' : '' }}</v-flex
						>
						<v-flex xs6 :class="waitings.length < 10 ? 'waitingList' : 'waitingListBig'">{{ waiting.Num }}</v-flex>
					</v-layout>
				</div>
			</v-flex>
			<v-flex lg8 xs12 class="pl-6">
				<div :class="nowWidth > 1081 ? 'leftContent' : 'leftContent1'">
					<p :class="nowWidth > 1081 ? 'headInfo' : 'headInfo1'">대기번호</p>
					<div v-if="nowWidth < 1081 && counselorData.length > 10" :class="nowWidth > 1081 ? 'waitNum' : 'waitNum1'">
						{{ waitings[0].Num }}
					</div>
					<div v-else :class="nowWidth > 1081 ? 'waitNum' : 'waitNum1'">{{ waitings[0].Num }}</div>
					<v-flex v-if="nowWidth < 1081 && counselorData.length > 10" :class="nowWidth > 1081 ? 'toSeat' : 'toSeat1'"
						>상담석<span> {{ waitings[0].seat !== 0 ? waitings[0].seat : '' }}</span
						>번으로 오십시오</v-flex
					>
					<v-flex v-else :class="nowWidth > 1081 ? 'toSeat' : 'toSeat1'" :style="'margin-top: 40px;'"
						>상담석<span class="color-Actvie"> {{ waitings[0].seat }}</span
						>번으로 오십시오</v-flex
					>
					<!-- <v-layout class="next-waitng-datas-layout" align-center v-if="!$store.state.direct_reserveList.includes($route.params.code)">
						<div class="next-waitng-datas">
							다음 상담 대기번호:
							<span v-if="waitingsListViews.length > 0">
								{{ waitingsListViews.map(x => x.waitingnum).join(', ') }}
							</span>
						</div>
					</v-layout> -->
				</div>
			</v-flex>
		</v-layout>

		<!-- 하단 waiting List -->
		<v-layout v-if="nowWidth < 1081" class="mt-7">
			<v-flex xs2 class="bottomWaiting1">
				<div class="bottomWait1">대기번호</div>
				<div class="bottomWait">상담석</div>
			</v-flex>

			<v-flex v-for="(waiting, i) in waitings.slice(0, bottomSlice)" :key="i" class="bottomWaiting">
				<div class="bottomWaitNum1" :class="i % 2 === 0 ? 'grayBack' : 'blackBack'">{{ waiting.Num }}</div>
				<div class="bottomWaitNum" :class="i % 2 === 0 ? 'grayBack' : 'blackBack'">{{ waiting.seat }}</div>
			</v-flex>
		</v-layout>
		<v-layout v-if="nowWidth < 1081">
			<v-flex xs2 class="bottomWaiting1">
				<div class="bottomWait1">대기번호</div>
				<div class="bottomWait">상담석</div>
			</v-flex>

			<v-flex v-for="(waiting, i) in waitings.slice(bottomSlice, bottomEnd)" :key="i" class="bottomWaiting">
				<div class="bottomWaitNum1" :class="i % 2 === 0 ? 'grayBack' : 'blackBack'">{{ waiting.Num }}</div>
				<div class="bottomWaitNum" :class="i % 2 === 0 ? 'grayBack' : 'blackBack'">{{ waiting.seat }}</div>
			</v-flex>
		</v-layout>
		<alertModal2 :setdialog="alertModal2" />
	</div>
</template>

<script>
import { alertModal2 } from '@/components/index'
export default {
	components: {
		alertModal2,
	},
	data() {
		return {
			alertModal2: {
				dialog: false,
				text: '띵동 소리 활성화를 위하여 클릭해주세요.',
			},
			serverUrl: '',
			headTxt: '',
			logoUrl: '',
			waitings: [
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
				{ seat: null, Num: '' },
			],
			screenWidth: 0,
			voiceList: [], // 음성 재생 데이터
			greetingSpeech: new window.SpeechSynthesisUtterance(),
			synth: window.speechSynthesis,
			called: [], // call한 고객 Data
			bottomSlice: 0, // 하단 상담석 리스트 slice point
			bottomEnd: 0,
			calledUser: { seat: '', waitnum: '' }, // 현재 부른 고객
			counselorData: [], // 카운셀러 데이터
			socket: '',
			waitingsListViews: [],
		}
	},
	mounted() {
		this.reservedays()
		this.waitingsSocket()
	},
	async created() {
		this.screenWidth = window.innerWidth

		this.voiceList = this.synth.getVoices()
		this.alertModal2.dialog = true
		const audio = new Audio('/tingtong.wav')

		// 자동재생 가능 여부 체크
		try {
			// 음소거 상태로 시도
			audio.muted = true
			await audio.play()

			// 성공하면 음소거 해제 시도
			audio.muted = false
		} catch (error) {
			// 실패 시 사용자 인터랙션 대기
			this.voice()
		}
		this.synth.onvoiceschanged = () => {
			this.voiceList = this.synth.getVoices()
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		/// waitings
		waitingsSocket() {
			setInterval(() => {
				const data = {
					code: this.$route.params.code,
					stat: 1,
					seat_ne: 0,
					seat_null: false,
					csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
					cedate:
						this.$moment(new Date())
							.add(1, 'days')
							.format('YYYY-MM-DD') + 'T00:00:00.000Z',
					_limit: 10,
				}
				this.$store.dispatch('waitings', data).then(res => {
					if (res.data.waitings.length === 0) {
						if (this.counselorData.length >= 10) {
							this.waitings = [
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
								{ seat: null, Num: '' },
							]
						} else {
							this.waitings = []
							this.counselorData.forEach(() => {
								this.waitings.push({ seat: null, Num: '' })
							})
						}
					} else {
						const setData = res.data.waitings.sort((a, b) => {
							if (a.waitingnum < b.waitingnum) return 1
							if (a.waitingnum === b.waitingnum) return 0
							if (a.waitingnum > b.waitingnum) return -1
						})
						setData.forEach((element, i) => {
							if (i < 10) {
								this.waitings[i].seat = element.seat
								this.waitings[i].Num = element.waitingnum
							}
							let called = this.called.findIndex(e => e === Number(element.waitingnum))
							if (called === -1) {
								this.called.unshift(Number(element.waitingnum))
								this.calledUser.seat = element.seat
								this.calledUser.waitnum = element.waitingnum
								// var tingtong = new Audio('/tingtong.wav')
								// tingtong.play()
								if (this.called.length === 1) {
									setTimeout(() => {
										this.voice(0)
									}, 3000)
								} else {
									const maxNumber = this.called[this.called.length - 1]
									if (maxNumber < element.waitingnum) {
										setTimeout(() => {
											this.voice(0)
										}, 3000)
									}
								}
							}
						})
						let rest = this.waitings.length - res.data.waitings.length
						if (rest > 0) {
							for (let index = res.data.waitings.length; index < this.waitings.length; index++) {
								this.waitings[index].seat = null
								this.waitings[index].Num = ''
							}
						}
					}
				})
			}, 1500)
		},
		reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			this.$store.dispatch('reservedays', data).then(res => {
				this.headTxt = res.data.reservedays[0].title
				if (res.data.reservedays[0].business.QRlogo) {
					this.logoUrl = res.data.reservedays[0].business.QRlogo.url
				}
				const data = {
					business: res.data.reservedays[0].business.id,
				}
				this.$store.dispatch('counselors', data).then(res => {
					let counselorList = []
					this.counselorData = res.data.counselors
					if (res.data.counselors.length >= 10) {
						this.waitings = [
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
							{ seat: null, Num: '' },
						]

						this.bottomEnd = 10
						this.bottomSlice = 5
					} else {
						res.data.counselors.forEach(() => {
							counselorList.push({ seat: null, Num: '' })
						})
						this.waitings = counselorList
						this.bottomSlice = Math.ceil(this.waitings.length / 2)
						this.bottomEnd = this.waitings.length
						if (this.waitings.length % 2 === 1 && this.screenWidth < 1081) {
							this.waitings.push({ seat: null, Num: '' })
							this.bottomEnd = this.bottomEnd + 1
						}
					}
				})
			})
		},
		waitingsList() {
			const data = {
				code: this.$route.params.code,
				stat: 0,
				// seatcall: 0,
				csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
				cedate:
					this.$moment(new Date())
						.add(1, 'days')
						.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				limit: 5,
			}
			this.$store
				.dispatch('waitingNumber', data)
				.then(res => {
					this.waitingsListViews = res.data.waitings
				})
				.catch(() => {})
		},

		voice(i) {
			const speeh = new window.SpeechSynthesisUtterance()
			speeh.text = '대기번호' + this.waitings[i].Num + '번 고객님 상담석' + this.waitings[i].seat + '번으로 와주시기 바랍니다'
			let index = this.voiceList.findIndex(e => e.name === 'Google 한국의')
			speeh.voice = this.voiceList[index]
			window.speechSynthesis.speak(speeh)
		},
	},
}
</script>

<style lang="scss">
.next-waitng-datas-layout {
	height: auto;
	box-shadow: 6px 6px 9px rgb(0 0 0 / 20%);
	background: linear-gradient(to bottom left, #1e222d, #474b56);
	padding: 0px 16px;
	border-radius: 22px;
}
.next-waitng-datas {
	margin-left: 8px;
	white-space: nowrap;
	font-size: 2.5vw;
	color: #d8d8d8;
	span {
		color: #f6ffdb;
		font-size: 3vw;
	}
}
.board-title {
	color: #d8d8d8;
	font-size: 35px;
	font-weight: bold;
}
body::-webkit-scrollbar {
	width: 0 !important;
	display: none !important;
}
.boardNoscroll {
	overflow: hidden !important;
	-ms-overflow-style: none !important; /* IE and Edge */
	scrollbar-width: none !important; /* Firefox */
}
.boardNoscroll::-webkit-scrollbar {
	width: 0px;
	display: none !important; /* Chrome, Safari, Opera */
}
</style>
<style lang="scss" scoped>
.boardBackground {
	padding: 16px;
	background: #1a1a22;
	height: 100vh;
}
.boardHead {
	background: url('/image/header_bg.jpg');
	color: white;
	font-size: 6vh;
	font-weight: bold;
	text-align: center;
	padding: 3vh 0px;
}
.leftContent {
	text-align: center;
	height: 88vh;
	background: linear-gradient(to bottom left, #1e222d, #474b56);
	padding: 0px 16px;
	border-radius: 22px;
	box-shadow: 6px 6px 9px rgb(0 0 0 / 20%);
}
.leftContent1 {
	text-align: center;
	// height: 85vw;
	text-align: -webkit-center;
	background: linear-gradient(to bottom left, #1e222d, #474b56);
	padding: 16px;
	border-radius: 22px;
	box-shadow: 6px 6px 9px rgb(0 0 0 / 20%);
}
.waitListFlex {
	height: 88vh;
	padding: 16px;
	background: linear-gradient(to bottom left, #1e222d, #474b56);
	border-radius: 22px;
	box-shadow: 6px 6px 9px rgb(0 0 0 / 20%);
}
.waitNum {
	color: white;
	font-size: 400px;
	font-weight: bold;
	line-height: 300px;
	height: 300px;
	// margin: 9vh 5vw 5vh 5vw;
	text-align: -webkit-center;
}
.waitNum1 {
	color: white;
	// padding: 10vw 0vw 0vw 0vw;
	font-size: 40vw;
	font-weight: bold;
	margin: 0vh 5vw 0vh 5vw;
	text-align: -webkit-center;
	height: 58vw;
}
.seatInfo {
	color: #f08300;
	font-size: 6vh;
	font-weight: bold;
	margin: 9vh 5vw 5vh 5vw;
}

.numBar {
	color: #d8d8d8;
	font-size: 40px;
	font-weight: bold;
	text-align: center;
	padding-bottom: 10px;
}
.waiting-border-setting {
	border-top: 1px solid #535353;
	border-bottom: 1px solid #535353;
}
.waitingList {
	line-height: 0px;
	color: #f6ffdb;
	font-size: 50px;
	font-weight: bold;
	text-align: center;
	padding: 0.5vh 0px;
	// max-height: 4.92vw;
}
.waitingListBig {
	line-height: 0px;
	color: #f6ffdb;
	font-size: 50px;
	font-weight: bold;
	text-align: center;
	padding: 0.5vh 0px;
	// max-height: 4.92vw;
}
.waitingList1 {
	line-height: 0px;
	color: #afefff;
	font-size: 50px;
	font-weight: bold;
	text-align: center;
	padding: 0.5vh 0px;
	// max-height: 4.92vw;
}
.waitingList1Big {
	line-height: 0px;
	color: #afefff;
	font-size: 50px;
	font-weight: bold;
	text-align: center;
	padding: 0.5vh 0px;
	// max-height: 4.92vw;
}
.called {
	background: #004e50;
}

.callCustomer {
	font-size: 3vw;
	text-align: center;
	font-weight: bold;
	border-style: solid;
	border-width: 3px 0px 0px 0px;
	border-color: white;
	border-style: solid;
	color: white;
	height: 18.1vh;
}
.callCustomer1 {
	font-size: 6.7vw;
	margin-bottom: 24vw !important;
	text-align: center;
	font-weight: bold;
	color: white;
	height: 20vw;
}
.boardLogo {
	margin-top: -4.5vh;
}
.hideBtns {
	display: none;
}
.bottomWaiting1 {
	text-align: center;
	// width: 30vw;
	min-width: 16vw;
	max-width: 16vw;
	color: white;
	font-size: 3.6vw;
	font-weight: 500;
	font-weight: 500;
	border-style: solid;
	border-width: 0.1px 0px 0px 0px;
	border-color: #8e8e8e;
	// border-style: solid;
	// border-width: 1px 0px 0px 0px;
	// border-color: #ffffff7d;
	// border-style: solid;
}
.bottomWaiting {
	text-align: center;
	width: 20vw;
	color: white;
	font-size: 3.6vw;
	font-weight: 500;
	border-style: solid;
	border-width: 0.1px 0px 0px 0px;
	border-color: #8e8e8e;
}
.bottomWait {
	border-style: solid;
	border-width: 0.1px 0px 0px 0px;
	border-color: #8e8e8e;
	padding: 3.9vw 0vw;
	height: 13.7vw;
}
.bottomWait1 {
	color: #9fd8f7;
	padding: 3.9vw 0vw;
	height: 13.7vw;
}
.bottomWaitNum {
	border-style: solid;
	border-width: 0.1px 0px 0px 0px;
	border-color: #8e8e8e;
	padding: 2.865vw 0vw;
	font-weight: bold;
	font-size: 5vw;
	height: 13.7vw;
}
.bottomWaitNum1 {
	color: #9fd8f7;
	padding: 2.865vw 0vw;
	font-weight: bold;
	font-size: 5vw;
	height: 13.7vw;
}
.parentBox {
	height: 77vh;
	display: flex;
	flex-direction: column;
	border: 1px solid #5b5b5b;
	border-radius: 11px;
}

.grayBack {
	background: #202020;
	flex-grow: 1;
}
.blackBack {
	flex-grow: 1;
}
.headInfo {
	padding: 80px 0px 0px 0px !important;
	color: #d8d8d8;
	font-size: 60px;
	font-weight: bold;
}
.headInfo1 {
	margin: 8% 0px 0px 0px !important;
	color: #d8d8d8;
	font-size: 11.5vw;
	font-weight: bold;
}
.toSeat {
	white-space: nowrap;
	color: white;
	font-weight: 500;
	font-size: 5vw;
	// line-height: 8vw;
	// margin-top: 40px;
	span {
		color: #afefff;
		font-weight: 700;
		font-size: 8vw;
	}
}
.toSeat1 {
	white-space: nowrap;
	color: white;
	font-weight: 500;
	font-size: 7vw;
	margin: -2vw 0px 7vw 0px !important;
	span {
		font-weight: bold;
		font-size: 11vw;
	}
}
</style>
